// @flow

import createApiModule from "../create-api-module";

import { type PathParams } from "./cancel-event.d";

const { reducer, actions } = createApiModule(
    "cancelEvent",
    ({ uuid }: PathParams) => `/ays-series-event-management/events/${uuid}`,
    {
        method: "DELETE",
    },
);

export const load = (uuid: string) => (dispatch: *) =>
    dispatch(
        actions.load({
            path: {
                uuid,
            },
        }),
    );
export const clear = actions.clear;
export const refetch = actions.refetch;
export const ERROR = "Could not cancel this event!";
export default reducer;
